import { Controller } from "@hotwired/stimulus"

export default class ModalController extends Controller {
  static values = { target: String }

  declare readonly targetValue: string

  private handleKeydown!: (event: KeyboardEvent) => void

  connect() {
    this.handleKeydown = this.onKeydown.bind(this)
    document.addEventListener("keydown", this.handleKeydown)
  }

  disconnect() {
    document.removeEventListener("keydown", this.handleKeydown)
  }

  open(event?: Event) {
    event?.preventDefault()
    const target = this.getTarget(event)
    if (target) {
      target.classList.remove("hidden")
      document.body.style.overflow = "hidden"
    }
  }

  close(event?: Event) {
    event?.preventDefault()
    const target = this.getTarget(event) ?? (this.element as HTMLElement)
    target.classList.add("hidden")
    document.body.style.overflow = ""
  }

  toggle(event?: Event) {
    event?.preventDefault()
    const target = this.getTarget(event)
    if (target) target.classList.toggle("hidden")
  }

  private getTarget(event?: Event): HTMLElement | null {
    const el = event?.currentTarget as HTMLElement | null
    const selector = el?.dataset["modalTargetValue"] ?? this.targetValue
    if (selector) return document.querySelector<HTMLElement>(selector)
    return null
  }

  private onKeydown(event: KeyboardEvent) {
    if (event.key !== "Escape") return
    document.querySelectorAll<HTMLElement>("[data-controller~='modal']:not(.hidden)").forEach((el) => {
      el.classList.add("hidden")
      document.body.style.overflow = ""
    })
  }
}
